import { render, staticRenderFns } from "./CandidatePicker.vue?vue&type=template&id=024a664c&scoped=true"
import script from "./CandidatePicker.vue?vue&type=script&lang=ts"
export * from "./CandidatePicker.vue?vue&type=script&lang=ts"
import style0 from "./CandidatePicker.vue?vue&type=style&index=0&id=024a664c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024a664c",
  null
  
)

export default component.exports